import React from "react";
import App from "./../app.jsx";
import { Navigate } from "react-router-dom";

import WorkOrders from "./../pages/work-order/orders";
import Dashboard from "./../pages/dashboard/dashboard.js";
import PrivateRoute from "../lib/PrivateRoute.jsx";
import PagesLogin from "./../pages/pages/login.js";
import PagesLoginByPass from "./../pages/pages/login-bypass";
import Calendar from "./../pages/calendar/calendar.js";
import PublicRegister from "../pages/pages/public-register";
import AssetManagement from "../pages/assets/list.js";
import AssetAdd from "../pages/assets/add.js";
import PartManagement from "../pages/parts_inventory/list_part.js";
import InventoryManagement from "../pages/parts_inventory/inventory.js";
import CompanyConfiguration from "../pages/configurations/company";
import LocationConfiguration from "../pages/configurations/location";
import RolesConfiguration from "../pages/configurations/roles-cmms";
import UserConfiguration from "../pages/configurations/users";
import VendorList from "../pages/vendor/list";
import VendorAdd from "../pages/vendor/add";
import CustomerList from "../pages/customer/list";
import CustomerAdd from "../pages/customer/add";
import PartsAdd from "../pages/parts_inventory/add";
import AssetDetail from "../pages/assets/detail";
import WorkOrderAdd from "../pages/work-order/add";
import TeamConfiguration from "../pages/configurations/team";
import WorkOrderDetail from "../pages/work-order/detail.js";
import Checklist from "../pages/Checklist/list.js";
import AddChecklist from "../pages/Checklist/add.js";
import { PermissionChecker } from "../components/PermissionChecker/index.jsx";
import { PERMISSIONS } from "./app-permissions-cmms.js";
import ImportPage from "../pages/configurations/import/index.jsx";
import PageReset from "../pages/pages/reset.js";
import EmailActivate from "../pages/pages/email-activate";
import CategoryConfiguration from "../pages/configurations/category/index.jsx";
import PurchaseOrderList from "../pages/purchase_order/list.js";
import AddPurchaseOrder from "../pages/purchase_order/add.js";
import DetailPurchaseOrder from "../pages/purchase_order/detail.js";
import WorkOrderDetailRequest from "../pages/work-order/detail-request.js";
import SetupCenter from "../pages/setup-center";
import AnalyticsCMMS from "../pages/analytics_cmms/analytics";
import ROIPublic from "./../pages/pages/roi-public.js";
import PrintQRCode from "../pages/qrcode/index.jsx";
import QuotationList from "../pages/quotation/list.js";
import AddQuotation from "../pages/quotation/add.js";
import PublicRequest from "../pages/request/add";
import DetailQuotation from "../pages/quotation/detail.js";
import ChatAssistant from "../pages/ai/ChatAssistant.jsx";
import WhatsappGateway from "../pages/configurations/whatsapp-gateway";
import { ChatAssistantIFrame } from "../pages/ai/ChatAssistantIFrame.jsx";
import Documents from "../pages/pages/documentation";
import DocumentChat from "../pages/pages/doc-chat";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Navigate to="/work-order/list" />
          </PrivateRoute>
        ),
      },
      { path: "login", element: <PagesLogin /> },
      { path: "chat-assistant", element: <ChatAssistantIFrame /> },
      { path: "login-by-pass/*", element: <PagesLoginByPass /> },
      { path: "public-request/:token", element: <PublicRequest /> },
      { path: "public-register", element: <PublicRegister /> },
      { path: "roi-calculator", element: <ROIPublic /> },
      { path: "password/*", element: <PageReset /> },
      { path: "account/*", element: <EmailActivate /> },
      {
        path: "setup-center",
        element: (
          <PrivateRoute>
            <SetupCenter />
          </PrivateRoute>
        ),
      },
      {
        path: "analytics",
        element: (
          <PrivateRoute>
            <AnalyticsCMMS />
          </PrivateRoute>
        ),
      },

      {
        path: "checklist/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <Checklist />
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <AddChecklist />
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <AddChecklist />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "work-order/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <WorkOrders />
              </PrivateRoute>
            ),
          },
          {
            path: "calendar",
            element: (
              <PrivateRoute>
                <Calendar />
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={[PERMISSIONS.CREATE_WO]}>
                  <WorkOrderAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker permissions={[PERMISSIONS.EDIT_WO]}>
                  <WorkOrderAdd />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <WorkOrderDetail />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "request/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <WorkOrders isRequest />
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PermissionChecker>
                  <WorkOrderAdd isRequest />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PermissionChecker>
                  <WorkOrderAdd isRequest />
                </PermissionChecker>
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <WorkOrderDetailRequest />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "assets/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <AssetManagement />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                {" "}
                <AssetAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                {" "}
                <AssetAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                {" "}
                <AssetDetail />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "document/*",
        children: [
          {
            path: "doc",
            element: (
              <PrivateRoute>
                {" "}
                <Documents />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "doc-chat",
            element: (
              <PrivateRoute>
                {" "}
                <DocumentChat />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "video",
            element: (
              <PrivateRoute>
                {" "}
                <Documents />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "vendor/*",
        children: [
          {
            path: "management",
            element: (
              <PrivateRoute>
                <VendorList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <VendorAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <VendorAdd />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "customer/*",
        children: [
          {
            path: "management",
            element: (
              <PrivateRoute>
                <CustomerList />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <CustomerAdd />{" "}
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <CustomerAdd />{" "}
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "part/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PartManagement />
              </PrivateRoute>
            ),
          },
          {
            path: "inventory",
            element: (
              <PrivateRoute>
                <InventoryManagement />
              </PrivateRoute>
            ),
          },
          {
            path: "add",
            element: (
              <PrivateRoute>
                <PartsAdd />
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <PartsAdd />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "purchase-order/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <PurchaseOrderList />
              </PrivateRoute>
            ),
          },

          {
            path: "add",
            element: (
              <PrivateRoute>
                <AddPurchaseOrder />
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <AddPurchaseOrder />
              </PrivateRoute>
            ),
          },
          {
            path: "duplicate/:id",
            element: (
              <PrivateRoute>
                <AddPurchaseOrder duplicate={true} />
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <DetailPurchaseOrder />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "quotation/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <QuotationList />
              </PrivateRoute>
            ),
          },

          {
            path: "add",
            element: (
              <PrivateRoute>
                <AddQuotation />
              </PrivateRoute>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <PrivateRoute>
                <AddQuotation />
              </PrivateRoute>
            ),
          },
          {
            path: "duplicate/:id",
            element: (
              <PrivateRoute>
                <AddQuotation duplicate={true} />
              </PrivateRoute>
            ),
          },
          {
            path: "detail/:id",
            element: (
              <PrivateRoute>
                <DetailQuotation />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "inventory/*",
        children: [
          {
            path: "list",
            element: (
              <PrivateRoute>
                <InventoryManagement />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "setup/*",
        children: [
          {
            path: "company",
            element: (
              <PrivateRoute>
                <CompanyConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "whatsapp-gateway",
            element: (
              <PrivateRoute>
                <WhatsappGateway />
              </PrivateRoute>
            ),
          },
          {
            path: "location",
            element: (
              <PrivateRoute>
                <LocationConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "category",
            element: (
              <PrivateRoute>
                <CategoryConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "roles",
            element: (
              <PrivateRoute>
                <RolesConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "users",
            element: (
              <PrivateRoute>
                <UserConfiguration />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "workers/*",
        children: [
          {
            path: "people",
            element: (
              <PrivateRoute>
                <UserConfiguration />
              </PrivateRoute>
            ),
          },
          {
            path: "teams",
            element: (
              <PrivateRoute>
                <TeamConfiguration />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: "import",
        element: (
          <PrivateRoute>
            <ImportPage />
          </PrivateRoute>
        ),
      },
      {
        path: "qrcode",
        element: (
          <PrivateRoute>
            <PrintQRCode />
          </PrivateRoute>
        ),
      },
    ],
  },
];

export default AppRoute;
